import type { CreatePositionInput } from "@solomon-apps/shared";

import type { PositionVerificationChallenge } from "./clientPrograms";
import { orgApiFetch } from "./orgApiFetch";

export type RegisterWalletInput = Omit<CreatePositionInput, "programSurfaceUuid" | "metadata" | "externalPositionId">;
export interface WalletRegistration {
    uuid: string;
    address: string;
    status: string;
    positionCount: number;
}

export function issueWalletEnrollmentChallenge(
    input: Pick<RegisterWalletInput, "walletAddress" | "sourceKind" | "signerAddress" | "multisigProgramId">
): Promise<PositionVerificationChallenge> {
    return orgApiFetch<PositionVerificationChallenge>("/api/org/client/wallet-enrollment/challenge", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
}

export function registerClientWallet(input: RegisterWalletInput): Promise<WalletRegistration> {
    return orgApiFetch<WalletRegistration>("/api/org/client/wallet-enrollment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(input)
    });
}
